module.exports = __webpack_public_path__ + "static/media/feature_4_4.2e43d792.jpg";